/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  today: 'à¤à¤',
  now: 'à¤à¤­à¥',
  backToToday: 'à¤à¤ à¤¤à¤',
  ok: 'à¤ à¥à¤',
  clear: 'à¤¸à¥à¤ªà¤·à¥à¤',
  month: 'à¤®à¤¹à¥à¤¨à¤¾',
  year: 'à¤¸à¤¾à¤²',
  timeSelect: 'à¤¸à¤®à¤¯ à¤à¤¾ à¤à¤¯à¤¨ à¤à¤°à¥à¤',
  dateSelect: 'à¤¤à¤¾à¤°à¥à¤à¤¼ à¤à¥à¤¨à¥à¤',
  weekSelect: 'à¤à¤ à¤¸à¤ªà¥à¤¤à¤¾à¤¹ à¤à¥à¤¨à¥à¤',
  monthSelect: 'à¤à¤ à¤®à¤¹à¥à¤¨à¤¾ à¤à¥à¤¨à¥à¤',
  yearSelect: 'à¤à¤ à¤µà¤°à¥à¤· à¤à¥à¤¨à¥à¤',
  decadeSelect: 'à¤à¤ à¤¦à¤¶à¤ à¤à¥à¤¨à¥à¤',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'à¤ªà¤¿à¤à¤²à¤¾ à¤®à¤¹à¥à¤¨à¤¾ (à¤ªà¥à¤à¤à¤ª)',
  nextMonth: 'à¤à¤à¤²à¥ à¤®à¤¹à¥à¤¨à¥ (à¤ªà¥à¤à¤¡à¤¾à¤à¤¨)',
  previousYear: 'à¤ªà¤¿à¤à¤²à¥ à¤¸à¤¾à¤² (Ctrl + à¤¬à¤¾à¤à¤)',
  nextYear: 'à¤à¤à¤²à¥ à¤¸à¤¾à¤² (Ctrl + à¤¦à¤¾à¤¹à¤¿à¤¨à¤¾)',
  previousDecade: 'à¤ªà¤¿à¤à¤²à¤¾ à¤¦à¤¶à¤',
  nextDecade: 'à¤à¤à¤²à¥ à¤¦à¤¶à¤',
  previousCentury: 'à¤ªà¥à¤à¥à¤²à¥ à¤¶à¤¤à¤¾à¤¬à¥à¤¦à¥',
  nextCentury: 'à¤à¤à¤²à¥ à¤¸à¤¦à¥'
};
